<div *ngIf="config().loading.style === 'spinner' && (layoutService.loading$ | async)"
     class="loading-shade">
  <mat-spinner diameter="70" color="primary"></mat-spinner>
</div>

<div class="container container--{{ config().layout.style }} {{ config().layout.background }}"
     [class.fixed-footer]="!config().footer.hidden">

  <app-header *ngIf="!config().header.hidden"></app-header>
  <app-location-label *ngIf="!config().locationLabel.hidden"></app-location-label>
  <app-language-switch
    *ngIf="!config().languageSwitch.hidden"
    [class.checked-in]="(lcoService.checkedIn$ | async) && !config().locationLabel.hidden"></app-language-switch>

  <main
    [class.checked-in]="(lcoService.checkedIn$ | async) && !config().lcoMenu.hidden"
    [@routerTransition]="prepareRoute(outlet)">
    <router-outlet #outlet="outlet"></router-outlet>
  </main>

  <app-footer-step-nav *ngIf="!config().footer.hidden"></app-footer-step-nav>
  <app-footer-lco-nav *ngIf="(lcoService.checkedIn$ | async) && !config().lcoMenu.hidden"></app-footer-lco-nav>
</div>
